import { ImageNodeSpec, IMAGE_KEY } from '@techchange/pm-specs';

import AltTooltip from './components/AltTooltip';
import ImageButton from './components/ImageButton';
import ImageToolbar from './components/ImageToolbar';
import imageViewPlugin, { imageViewPluginKey } from './plugins/imageView';

const image = {

	nodes() {

		return {
			[IMAGE_KEY]: ImageNodeSpec,
		};

	},

	plugins() {

		return [imageViewPlugin()];

	},

	toolbarButtons() {

		return [{ Button: ImageButton, key: 'ImageButton' }];

	},

	tooltips() {

		return [
			{
				Tooltip: ImageToolbar,
				key: (state) => {

					const { imageNode } = imageViewPluginKey.getState(state);

					return imageNode ? imageNode.attrs.src : 'ImageToolbar';

				}
			},
			{
				Tooltip: AltTooltip,
				key: () => 'AltTooltip',
			}
		];

	},

};

export default image;
